import React, { useEffect, useState } from 'react';

const CodePageView = (props: any) => {
  const { ecodeId } = props;
  const [mod, setMod] = useState<any>(null);
  useEffect(() => {
    window.weappEcodesdk.asyncImport(ecodeId, 'EBPage').then((_mod: any) => {
      console.log('mod:', mod);
      setMod(_mod || null);
    });
  }, [ecodeId]);
  if (!mod) return null;
  const EcodeComponent = mod.default || mod;
  return <EcodeComponent weId={`${props.weId || ''}_yi839u`} />;
};

export default CodePageView;
